export enum MaterialTipoEnum {
  CONSUMO = 1,
  PERMANENTE = 2,
  SERVICO = 3
}
